import { useMemo } from "react";
import { useAppointments } from "@src/packages/care/hooks/useAppointments";
import type { Phase } from "./useCycles";
import {
  findRetrievalClinicInstructions,
  retrievalAppointmentIds,
} from "../presenters/retrievalPreparation";

/**
 * The retrieval instructions her clinic recorded on this cycle's phases, or null.
 *
 * The appointment list is only read when a retrieval procedure is booked through
 * an appointment, so a cycle without one costs no request.
 */
export function useRetrievalClinicInstructions(
  phases: readonly Pick<Phase, "type" | "procedures">[],
): string | null {
  const needsAppointments = retrievalAppointmentIds(phases).length > 0;
  const { data: appointments } = useAppointments({
    enabled: needsAppointments,
  });
  return useMemo(
    () =>
      findRetrievalClinicInstructions({
        phases,
        appointments: needsAppointments ? (appointments ?? []) : [],
      }),
    [phases, appointments, needsAppointments],
  );
}
